// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqonqa1{border-style:solid}\n._1h6dmuej{border-color:var(--ds-border,#091e4224)}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3incxg{height:264px}\n._kqswh2mm{position:relative}\n._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
